import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import UploadDocModel from "./UploadDocModel";
import { BoxHead, Underline } from "../../Styles/PageStyles";

export default function Documents({ docs, uploadDocMutate, isDocLoading, showUploadModel, setShowUploadModel }) {
  const [data, setData] = useState(docs || []);
  const [docType, setDocType] = useState(0);

  useEffect(() => {
    setData(docs || []);
  }, [docs]);

  const documentTypes = Array.from(new Set(data.map(doc => doc.type)))
    .map(type => {
      const doc = data.find(d => d.type === type);
      return {
        key: type,
        label: doc.title
      };
    });

  const allDocumentTypes = [
    { key: 1, label: "Aadhaar Card" },
    { key: 2, label: "Aadhaar Card Back" },
    { key: 3, label: "Pan Card" },
    { key: 7, label: "Student/Employer Id" },
    { key: 6, label: "Police Verification" },
    { key: 5, label: "Rent Agreement" },
    { key: 4, label: "Tenant Photo" },
    { key: 11, label: "Rental Bond" },
    { key: 13, label: "Cancelled Cheque" },
    { key: 14, label: "Settlement Summary" },
    { key: 15, label: "Consent Form" },
    { key: 16, label: "CVIRMS" },
    { key: 50, label: "Others" }
  ].map(defaultType => {
    const existingType = documentTypes.find(t => t.key === defaultType.key);
    return existingType || defaultType;
  });

  return (
    <>
      <Wrapper>
        {showUploadModel && (
          <UploadDocModel
            docType={docType}
            isDocLoading={isDocLoading}
            uploadDocMutate={uploadDocMutate}
            setShowUploadModel={setShowUploadModel}
          />
        )}
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Documents
            <Underline />
          </BoxTitle>
        </BoxHead>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
          {allDocumentTypes.map((item, index) => {
            const docObject = data.find((doc) => doc.type === item.key);

            return (
              <div
                key={item.key}
                className="flex flex-col items-start bg-gray-100 p-4 rounded-lg shadow"
              >
                <span className="block text-sm font-medium text-blue-600 mb-2">
                  {item.label}
                </span>

                {docObject ? (
                  <a
                    href={docObject.value}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-blue-600 mb-4 underline hover:text-blue-800"
                  >
                    View/Download File
                  </a>
                ) : (
                  <p className="text-sm text-gray-500 mb-4">
                    No document uploaded
                  </p>
                )}

                {item.key !== 11 && item.key !== 14 && (
                  <label
                    htmlFor={`upload-${index}`}
                    className="text-sm text-gray-800 cursor-pointer hover:underline"
                    onClick={() => {
                      setShowUploadModel(true);
                      setDocType(item.key);
                    }}
                  >
                    Upload File
                  </label>
                )}
              </div>
            );
          })}
        </div>
      </Wrapper>
    </>
  );
}

const Wrapper = tw.div`space-y-4 mt-2`;
const Title = tw.h3`text-md md:text-md lg:text-md tracking-wider font-semibold text-black`;
export const BoxTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg  text-black font-semibold  space-x-2 items-center  mb-5  rounded-md `;